import app from 'flarum/forum/app';
import addEditUserModalWarnings from './addEditUserModalWarnings';
import addFrameAuth from './addFrameAuth';
import removeSettings from './removeSettings';
import addLoginButton from './addLoginButton';
import addWelcomeModal from './addWelcomeModal';
import fixReplyCount from './fixReplyCount';
import addPostType from './addPostType';

app.initializers.add('kilowhat-wordpress', () => {
    addEditUserModalWarnings();
    addFrameAuth();
    addLoginButton();
    addPostType();
    addWelcomeModal();
    fixReplyCount();
    removeSettings();
});
